module.exports = __webpack_public_path__ + "media/images/views/job/check-4cb903859dd0defa3961b3d3499ed131.svg";